export const UAM_ACTIVATED = 'activated';
